import INTOUCH_API from "../services/Api";
import PersonalAccount from "../store/PersonalAccount";
import { GENDER_CHANGED_AT_KEY } from "../utils/constants";

export default function useChangeGender() {
  const change = async () => {
    await INTOUCH_API.requestManager(
      "user_data_update",
      {
        gender: PersonalAccount.user.gender === "male" ? "female" : "male",
        email: PersonalAccount.user.email,
      },
      () => {
        // item 3: фиксируем момент смены пола. Всё, что отвечено раньше, дано из
        // ПРОТИВОПОЛОЖНОЙ роли (см. GENDER_CHANGED_AT_KEY) — предложение «использовать
        // прошлые ответы» такие ответы больше не показывает.
        try {
          localStorage.setItem(GENDER_CHANGED_AT_KEY, new Date().toISOString());
        } catch (e) {
          // приватный режим — просто не помечаем
        }
      },
      (error) => {}
    ).finally(() => {});
  };

  return {
    change,
  };
}
